import { NgModule } from '@angular/core';
import {
  RouterModule,
  provideRouter,
  withComponentInputBinding,
} from '@angular/router';

import { routes } from './core.routes';

@NgModule({
  imports: [],
  exports: [RouterModule],
  providers: [provideRouter(routes, withComponentInputBinding())],
})
export class CoreRoutingModule {}
